<template>
  <div>
    <b-row align-v="center">
      <b-col  style="padding: 0px">
        <Icon
          v-if="VALUE == 2"
         
          icon="material-symbols:check-circle"
          color="#28c76f"
          width="25"
          height="25"
        />
      </b-col>
      <b-col  style="padding: 0px">
        <h6 style="font-weight: 400; margin: 0px !important; padding: 0px !important">
          {{ VALUE == "2" ? "Aktif" : "Pasif" }}
        </h6>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { Icon } from "@iconify/vue2";

export default {
  components: {
    Icon,
  },
  data() {
    return {
      VALUE: "",
    };
  },
  created() {
    this.VALUE = this.params.value;
  },
};
</script>
